import { IconX } from "@tabler/icons-react"; 
import SelectInput from "../../../components/Select";
import InputField from "../../../components/common/InputField";

type Forword3PlModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function Forword3PlModal({
  open,
  onClose,
}: Forword3PlModalProps) {
  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-[#F7F6F2] rounded-2xl ">
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
          <h2 className="text-2xl">Forwarded 3PL Company</h2>
          <button
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
            onClick={onClose}
          >
            <IconX size={24} />
          </button>
        </div>

        <div className="w-[655px] p-4 grid grid-cols-2 gap-4">
          <SelectInput
            label="Select 3PL Company"
            className=" "
            name=""
            selectOptions={[]}
          />
          <InputField label="No. of Pieces" placeholder="2" className=" " />
        </div>

        <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
